<template>
    <v-row id="static-page__seo">
        <v-col cols="12">
            <h2 class="mt-4">SEO</h2>
        </v-col>
        <v-col cols="12" sm="4">
            <app-input
                data-testid="static-page-seo-title-input"
                class="static-page-seo-title-input"
                :type="'text'"
                label="Page Title"
                v-model.trim="currentStaticPage.meta_title"
                :rules="{ required: true }"
                :useValidation="true"
            />
        </v-col>
        <v-col cols="12" sm="4">
            <app-input
                data-testid="static-page-seo-description-input"
                class="static-page-seo-description-input"
                :type="'text'"
                label="Meta Description"
                v-model.trim="currentStaticPage.meta_description"
                :rules="{ required: true }"
                :useValidation="true"
            />
        </v-col>
        <v-col cols="12" sm="4">
            <app-input
                data-testid="static-page-seo-keywords-input"
                class="static-page-seo-keywords-input"
                :type="'text'"
                label="Meta Keywords"
                v-model.trim="currentStaticPage.meta_keywords"
            />
        </v-col>
    </v-row>
</template>

<script>
export default {
  computed: {
    currentStaticPage: {
      get() {
        return this.$store.state.staticPage.currentStaticPage;
      },
      set(newValue) {
        this.$store.commit("setCurrentStaticPageData", newValue);
      }
    }
  }
};
</script>
